import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Modal, ModalBackdrop, ModalContent, ModalHeader, ModalCloseButton } from "@/components/ui/modal";
import { HStack } from "@/components/ui/hstack";
import { Button } from "@/components/ui/button";
import { View } from '@/components/ui/view';
import { IconMC } from "@/components/media/IconsV2";
import React, { useState, useEffect } from 'react'
import { ScrollView } from "react-native-gesture-handler";

export const ModalWrapper = (modal) => {

  const whenClose = (...option) => {
    // ? `Modal.onClose` will trigger on pressing [Escape] even if the model is already closed.
    if (modal.isVisible) modal.onClose(...option);
  }

  const actionSubmit = modal.buttonSubmit.action === 'negative' ? 'bg-error-600' : '';

  let [is_initialized, setIsInitialized] = useState(false);
  let [is_initialized_buffer, setIsInitializedBuffer] = useState();


  useEffect(() => {
    // ? Remove model if not needed after delay to not cut of animations
    const is_initialized_state = modal.onClose !== undefined;

    clearTimeout(is_initialized_buffer);

    if (is_initialized_state) {
      setIsInitialized(true);
    } else {
      setIsInitializedBuffer(setTimeout(() => {
        setIsInitialized(false);
      }, 500));
    }

  }, [modal.onClose]);


  return is_initialized && (
    <Modal
      isOpen={modal.isVisible}
      onClose={whenClose}
      animationInTiming={0}
      animationOutTiming={0}
      avoidKeyboard={true}
    >
      <ModalBackdrop />
      <ModalContent className="max-w-[700px] max-h-[80%]">
        <ModalHeader className="mb-2">
          <Text bold className="text-secondary-900 text-2xl">{modal.title}</Text>
          <ModalCloseButton className='bg-secondary-100'>
              <View className='bg-primary-50 border-2 border-primary-900 rounded-[4px] p-1 w-fit self-end'>
                <IconMC className='text-primary-900' size={24} name='close' />
              </View>
          </ModalCloseButton>
        </ModalHeader>
        <ScrollView>
          <VStack space='md'>
            {modal.children}
          </VStack>
        </ScrollView>
        <HStack space='lg' className="mt-5 justify-end">
          {modal.buttonBack && (
            <Button variant="outline" onPress={() => { modal.onBack() }} className="self-end py-3 px-5 border-primary-900">
              <Text className="text-lg text-primary-900">{modal.buttonBack.text}</Text>
            </Button>
          )}
          {modal.buttonSubmit && (
            <Button disabled={modal.isWaiting || !modal.isVisible || modal.disabled} onPress={() => { modal.onSubmit() }}  className={` ${modal.disabled ? "bg-secondary-700" : "bg-primary-900"} self-end py-3 px-5 ${actionSubmit} `}>
              <Text className="text-lg text-secondary-50">{modal.buttonSubmit.text}</Text>
            </Button>
          )}
        </HStack>
      </ModalContent>
    </Modal>
  );
}